// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import PageHeader from 'components/PageHeader/PageHeader'
import Subscribe from 'components/Subscribe/Subscribe'
import Share from 'components/Share/Share'
import SidebarLogin from 'components/Login/SidebarLogin'
import Footer from 'components/Footer/Footer'
import isElementInViewport from 'utilities/isElementInViewport'
import Locale from 'views/main/page/Locale'

const siteImage = siteData.featured_image_url
const siteImageSrcset = siteData.featured_image_srcset

class PageLayout extends React.Component {
	componentDidMount() {
		// Add class to html when scrolled to the top:

		// document.documentElement.classList.add( 'with-scroll-top' )

		// Test via a getter in the options object to see if the passive property is accessed
		this.supportsPassive = false

		try {
			var options = Object.defineProperty( {}, 'passive', {
				get: () => {
					this.supportsPassive = true
				}
			})

			window.addEventListener( 'test', null, options )
			window.removeEventListener( 'test', null, options )
		} catch( err ) {}

		// Listen for scroll events:
		window.addEventListener( 'scroll', this.handleScroll, this.supportsPassive ? { passive: true } : false )
	}

	componentWillUnmount() {
		window.removeEventListener( 'scroll', this.handleScroll )
	}

	handleScroll = () => {
		let viewportTop  = window.pageYOffset || document.documentElement.scrollTop,
			distance

		// viewportTop = viewportTop < 500 ? viewportTop : viewportTop - 500
		// viewportTop = viewportTop - 200

		// if ( 300 > top ) {
		// 	requestAnimationFrame( () => {
		// 		document.documentElement.classList.add( 'with-scroll-top' )
		// 	})
		// } else {
		// 	requestAnimationFrame( () => {
		// 		document.documentElement.classList.remove( 'with-scroll-top' )
		// 	})
		// }

		// Parallax:
		const parallaxes = document.querySelectorAll( '.parallax' )

		Array.from( parallaxes ).forEach( ( element ) => {
			let threshold = element.getAttribute( 'data-threshold' ) || false

			if ( isElementInViewport( element, threshold ) ) {
				distance = viewportTop * 0.12
				distance = distance.toFixed( 0 )

				element.style.transform = 'translate3d(0, -' + distance + 'px, 0)'
			}
		})
	}

	render() {
		let { match, page, hasSidebar } = this.props
		let className = 'is-page'
		let showResourcesSidebar = false

		if ( ! page ) {
			hasSidebar = false
		}

		if ( page && page.content_full_width ) {
			hasSidebar = false
		}

		if ( page && page.is_403 ) {
			hasSidebar = false
		}

		if ( hasSidebar ) {
			className += ' with-sidebar'
		}

		if ( '/resources-page/' == page.url || 'resource-category' == page.template || match.path.indexOf( 'resources' ) != -1 ) {
			showResourcesSidebar = true
		}

		const localesRoutes = siteData.locales ? siteData.locales.map( e => {
			return <Route path={ '/' + e.slug + '/' } component={ Locale } key={ e.slug } />
		}) : null

		return (
			<div className={ className }>
				<HeaderMobilePrimary />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />
					<HeaderPrimary />

					<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
						<Switch>
							<Route path="/" component={ PageHeader } />
						</Switch>
					</TransitionGroup>

					<section className="main">
						<div className="main-inner">
							<div className="primary-wrap">
								<ErrorBoundary>
									<div className="primary-content">
										<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
											<Switch>
												{ localesRoutes }

												<Route path="/" component={ Locale } />
											</Switch>
										</TransitionGroup>
									</div>
								</ErrorBoundary>
							</div>

							{ hasSidebar &&
								<div className="secondary-wrap">
									<div className="secondary-content">
										{ page && ( ! page.side_subscribe || ! page.side_subscribe.show ) &&
											<Subscribe
												sidebar={ true }
												text="Be notified when new resources are added"
											/>
										}

										{ page && page.side_subscribe && page.side_subscribe.show &&
											<Subscribe
												sidebar={ true }
												text={ page.side_subscribe.heading }
												action={ page.side_subscribe.action }
											/>
										}

										{ showResourcesSidebar &&
											<div className="side-menu">
												<div className="-inner">

													<Link className='image-link' to="/children">
														<div className='-inner'>
															<div className='-title'>
																<h3>Children</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/children.jpg` } alt='' />
															</div>
														</div>
													</Link>

													<Link className='image-link' to="/family">
														<div className='-inner'>
															<div className='-title'>
																<h3>Family</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/family.jpg` } alt='' />
															</div>
														</div>
													</Link>

													<Link className='image-link' to="/women">
														<div className='-inner'>
															<div className='-title'>
																<h3>Women</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/women.jpg` } alt='' />
															</div>
														</div>
													</Link>

													<Link className='image-link' to="/sabbath-school">
														<div className='-inner'>
															<div className='-title'>
																<h3>Sabbath School</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/sabbath-school.jpg` } alt='' />
															</div>
														</div>
													</Link>

													<Link className='image-link' to="/youth">
														<div className='-inner'>
															<div className='-title'>
																<h3>Youth</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/youth.jpg` } alt='' />
															</div>
														</div>
													</Link>

													<Link className='image-link' to="/pastor">
														<div className='-inner'>
															<div className='-title'>
																<h3>Pastors</h3>
															</div>

															<div className='-image'>
																<img src={ `${siteData.images_url}resources/pastors.jpg` } alt='' />
															</div>
														</div>
													</Link>
												</div>
											</div>
										}

										<div className="-share">
											<span className="-text">Share on:</span>

											<Share type="facebook">
												<i className="icon-facebook-square" aria-hidden="true"></i>
											</Share>

											<Share type="twitter">
												<i className="icon-twitter-square" aria-hidden="true"></i>
											</Share>

											<Share type="google-plus">
												<i className="icon-google-plus" aria-hidden="true"></i>
											</Share>
										</div>

										{ page && page.side_page && page.side_page.image_url &&
											<Link className="-page-link" to={ page.side_page.url }>
												<div className="-image">
													<img src={ page.side_page.image_url } alt={ page.side_page.title } />
												</div>

												<h4 dangerouslySetInnerHTML={ { __html: page.side_page.title } }></h4>

												<div className="-text" dangerouslySetInnerHTML={ { __html: page.side_page.excerpt } }></div>
											</Link>
										}

										{ page && page.side_menu && page.side_menu.content &&
											<div className="-custom">
												{ page.side_menu.heading_url &&
													<h3><a href={ page.side_menu.heading_url } dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></a></h3>
												||
													<h3 dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></h3>
												}

												<div dangerouslySetInnerHTML={ { __html: page.side_menu.content } }></div>
											</div>
										}
									</div>
								</div>
							}
						</div>
					</section>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		hasSidebar: state.site.hasSidebar
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageLayout )



// WEBPACK FOOTER //
// ./views/layouts/main/PageLayout.jsx